export const imageStyles = {
  width: 24,
  height: 24,
  mb: { xs: 2, md: 2.25 },
};

export const buttonStyles = {
  backgroundColor: "#FFDAC0 !important",
  opacity: "1 !important",
  fontSize: 14,
  borderRadius: 2,
  padding: { xs: 1.25, md: 1.8 },
};

export const iconStyles = {
  py: { xs: 0.75, md: 1.5 },
  px: { xs: 0.75 },
  backgroundColor: "#FFDEC6",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 2,
  "& svg": {
    width: 24,
    height: 24,
  },
};
